import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Button, Form, Input, Select, Switch } from 'antd'
import { Col, Grid, Row } from 'react-flexbox-grid'


const FormClient = forwardRef((props, ref) => {
    const {loading, onSubmitClient, isEditing, clientToEdit } = props
    const [form] = Form.useForm()

    const handleSubmit = values => {
        if (isEditing && clientToEdit) {
            const data = {
                ...clientToEdit,
                name: values.name !== undefined ? values.name : '',
                phone: values.phone !== undefined ? values.phone : '',
                email: values.email !== undefined ? values.email : [],
                enabled: values.enabled !== undefined ? values.enabled : false,
                cuil: values.cuil !== undefined ? values.cuil : '',
                type: values.type !== undefined ? values.type : false,
                interlocutor: values.interlocutor !== undefined ? values.interlocutor : '',
            }
            onSubmitClient(data)
        } else {
            const data = {
                name: values.name !== undefined ? values.name : '',
                phone: values.phone !== undefined ? values.phone : '',
                email: values.email !== undefined ? values.email : [],
                enabled: values.enabled !== undefined ? values.enabled : false,
                cuil: values.cuil !== undefined ? values.cuil : '',
                type: values.type !== undefined ? values.type : false,
                interlocutor: values.interlocutor !== undefined ? values.interlocutor : '',
            }
            onSubmitClient(data)
        }
    }

    const getInitialValues = () => {
        return {
            name: clientToEdit.name ? clientToEdit.name : undefined,
            phone: clientToEdit.phone ? clientToEdit.phone : undefined,
            email: clientToEdit.email ? clientToEdit.email : undefined,
            enabled: clientToEdit.enabled !== undefined ? clientToEdit.enabled : undefined,
            cuil: clientToEdit.cuil ? clientToEdit.cuil : undefined,
            type: clientToEdit.type !== undefined  ? clientToEdit.type : undefined,
            interlocutor: clientToEdit.interlocutor ? clientToEdit.interlocutor : undefined,
        }
    }

    const clearWorkOrder = () => {
        form.resetFields()
    }

    const onChangeSwitch = (checked) => {
        form.setFieldsValue({ type: checked })
    }

    return (
        <Grid>
            <Form onFinish={handleSubmit} form={form} initialValues={isEditing && getInitialValues()}>
                <Row>
                    <Col xs={12} md={4}>
                        <Form.Item name="name" rules={[{ required: true, message: 'Por favor, ingrese razón social' }]}>
                            <Input placeholder="Razón social"/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={4}>
                        <Form.Item name="cuil">
                            <Input type='number' placeholder="CUIL/CUIT"/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={4}>
                        <Form.Item name="enabled" rules={[{ required: true, message: 'Por favor, elija una opción' }]}>
                            <Select 
                                placeholder="Habilitado"
                                options={[
                                    { label: 'Si', value: true },
                                    { label: 'No', value: false },
                                ]}
                                allowClear
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={4}>
                        <Form.Item name="phone" rules={[{ required: true, message: 'Por favor, ingrese un teléfono' }]}>
                            <Input type='number' placeholder="Teléfono"/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={4}>
                        <Form.Item name="email" rules={[{ required: true, message: 'Por favor, ingrese un email' }]}>
                            <Input placeholder="Email"/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={4}>
                        <Form.Item name="type">
                            <Row>
                                <Col xs={4}>
                                    <p>Publico</p>
                                </Col>
                                {
                                    isEditing ?
                                        <Col xs={4}>
                                            <Switch onClick={onChangeSwitch} defaultChecked={clientToEdit.type}/>
                                        </Col>
                                        :
                                        <Col xs={4}>
                                            <Switch onChange={onChangeSwitch}/>
                                        </Col>
                                }
                                <Col xs={4}>
                                    <p>Privado</p>
                                </Col>
                            </Row>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={4}>
                        <Form.Item name="interlocutor">
                            <Input placeholder="Interlocutor"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row center="xs">
                    <Col xs={6}>
                        <Form.Item style={{ textAlign: 'center' }}>
                            <Button type="primary" htmlType="submit" loading={loading}>
                                {isEditing ? 'Actualizar' : 'Cargar'}
                            </Button>
                        </Form.Item>
                    </Col>
                    <Col xs={6}>
                        <Form.Item style={{ textAlign: 'center' }}>
                            <Button onClick={clearWorkOrder} loading={loading}>
                                {isEditing ? 'Restablecer' : 'Limpiar'}
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Grid>
    )

})

FormClient.propTypes = {
    loading: PropTypes.bool.isRequired,
    onSubmitClient:PropTypes.func.isRequired,
    isEditing:PropTypes.bool,
    clientToEdit: PropTypes.object,
}

export default FormClient